import React from "react";
import { leagueTypeKey } from "./leagueFormat";

// The three competition types, as ONE icon family.
//
// Drawn together on purpose: same 24 viewBox, same 1.7 stroke, same round caps,
// same muted grey. Borrowing a globe from one screen and a lock from another gave
// three glyphs with different weights sitting on the same line — this keeps the
// type line reading as a label rather than as artwork.
const GLYPHS = {
  // Public — a globe.
  public: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M3.5 12h17M12 3.5c2.2 2.3 3.4 5.3 3.4 8.5s-1.2 6.2-3.4 8.5c-2.2-2.3-3.4-5.3-3.4-8.5S9.8 5.8 12 3.5Z" />
    </>
  ),
  // Private — a closed padlock.
  private: (
    <>
      <rect x="4.5" y="10.5" width="15" height="10" rx="2" />
      <path d="M8 10.5V7.8a4 4 0 0 1 8 0v2.7" strokeLinecap="round" />
    </>
  ),
  // Cash — a dollar sign inside a circle.
  cash: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 6.8v10.4" strokeLinecap="round" />
      <path
        d="M14.6 9.4a2.4 2.4 0 0 0-2.4-1.4h-.6a2.1 2.1 0 0 0 0 4.2h.8a2.1 2.1 0 0 1 0 4.2h-.6a2.4 2.4 0 0 1-2.4-1.4"
        strokeLinecap="round"
      />
    </>
  ),
};

const LeagueTypeIcon = ({ game, type, className = "w-4 h-4", stroke = "#6B7280" }) => {
  const key = type || leagueTypeKey(game);
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke={stroke}
      strokeWidth="1.7"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {GLYPHS[key] || GLYPHS.public}
    </svg>
  );
};

export default LeagueTypeIcon;
